import Form from "/src/components/form/Form";
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import InputRange from '/src/components/UI/InputRange/InputRange';
import TodoList from '/src/components/UI/TodoList/TodoList';
import ButtonAction from "/src/components/UI/Button/Button";
import { useForm } from "react-hook-form";
import { useModal } from "@ebay/nice-modal-react"
import statementService from '/src/features/dataset/services/statementService';
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import ScrollIntoSlide from '/src/components/slider/sliderView/helpers/scrollIntoSlide';
import "./StatementModal.css"
import { configureRowStatement } from "../../../configureRowStatement";
function StatementModalBody({ data, title, dataset, is_button_back }) {

    if (data != null) {
        data.statements = data.statements.map(statement => { return { name: statement } })
        data.responses = data.responses.map(reponse => { return { name: reponse } })
    }

    const { register, setError, clearErrors, handleSubmit, control, formState: { errors }, formState, getValues, setValue } = useForm({
        mode: "onChange",
        defaultValues: {
            label: data?.label,
            statements: data ? data.statements : [],
            responses: data ? data.responses : []
        },
    });

    var registerObject = {
        register: register,
        setError: setError,
        clearErrors: clearErrors,
        control: control,
        setValue: setValue
    }

    const modal = useModal();
    const { onClose } = useModalHelper(modal);
    const { addStatement, updateStatement } = statementService;

    const onSubmit = async () => {
        /*
        var dataToSend = getValues();
        
        if (dataToSend.statementsRegisterInput != null  && dataToSend.statementsRegisterInput.trim().length != 0) {
            dataToSend.statements.push({ name: dataToSend.statementsRegisterInput })
        }

        if (dataToSend.responsesRegisterInput != null&&  dataToSend.responsesRegisterInput.trim().length != 0) {
            dataToSend.responses.push({ name: dataToSend.responsesRegisterInput })
        }

        var statementsData = []
        var responsesData = []
        for (let i = 0; i < dataToSend.statements.length; i++) {
            if (dataToSend.statements[i].name.trim().length != 0) {
                statementsData.push(dataToSend.statements[i].name);
            }
        }
        for (let i = 0; i < dataToSend.responses.length; i++) {
            if (dataToSend.responses[i].name.trim().length != 0) {
                responsesData.push(dataToSend.responses[i].name);
            }
        }
       */

        var dataToSend = getValues();

        //dataToSend.statements = statementsData

        //dataToSend.statements = dataToSend.statements.map(obj => obj.name);
        //dataToSend.responses = dataToSend.responses.map(obj => obj.name);
        dataToSend = configureRowStatement(dataToSend, "statements")
        dataToSend= configureRowStatement(dataToSend, "responses")
        console.log(dataToSend)

        let [response, error] = data ? await updateStatement(dataset.name, data.id, dataToSend) : await addStatement(dataset.name, dataToSend)
        if (error !== null) {
            console.log(error);
            return;
        }
        dataToSend.id = data ? data.id : response._id
        modal.resolve(dataToSend)
        onClose();
        return;
    };

    const checkSingleErrors = (data, nameColumn)=>{
        if (data[nameColumn].length == 0 && (data[nameColumn+"RegisterInput"] == null || data[nameColumn+"RegisterInput"] ?.replace(/\s/g, '').length == 0)) return true;
        if (data[nameColumn].every(element => element === null) && data[nameColumn+"RegisterInput"]?.replace(/\s/g, '').length == 0) return true;
        return false;
    }
    const checkErrors = () => {
        let dataForm = getValues();
        /*
        let responses = dataForm.responses;
        let statements = dataForm.statements
        let responseInput = dataForm.responsesRegisterInput;
        let statementInput = dataForm.statementsRegisterInput;
        /*/
        if (checkSingleErrors(dataForm, "responses") == true) return;
        if (checkSingleErrors(dataForm, "statements") == true) return;
        // if all the element are empty, useless to go further
        //if (responses.length == 0 && (responseInput == null || responseInput?.replace(/\s/g, '').length == 0)) return;
        //if (statements.length == 0 && (statementInput == null || statementInput?.replace(/\s/g, '').length == 0)) return;

        //if (responses.length == 0 && statements.length == 0 && statementInput == null  && statementInput.replace(/\s/g, '').length == 0 && responseInput?.replace(/\s/g, '').length == 0) return;
        // else, check if all element have a value
        /*
        if (responses.every(element => element === null) && responseInput?.replace(/\s/g, '').length == 0) {
            return;
        }
        */
       /*
        if (statements.every(element => element === null) && statementInput?.replace(/\s/g, '').length == 0) {
            return;
        }
        */

        // if we are here, mean all values are entered, we can delock the disabled button
        clearErrors();
    }

    return (
        <div>
            <Form className="edit-container" onSubmit={null}>
                <Form.Title>{title}</Form.Title>
                <Form.Body className="body-editModal-container">
                    <br />
                    <div>
                        <Field label="Label" />
                        <TextInput {...register('label', { required: true, minLength: 1, onChange: () => checkErrors() })} style={errors.label ? { borderColor: "red" } : {}} defaultValue={data ? data.label : ""} placeholder="Choose your label" />
                    </div>
                    {
                        /*
                    <div>
                        <Field label="Feeling" />
                        <InputRange {...register('feeling')} _setValue={setValue} value={data ? data.feeling : ""} min="0" max="10" />
                    </div>
                        */
                    }
                    <div className="statement-modal-bar" />
                    <div className="statement-container">
                        <Field label="Sentences" />
                        <TodoList registerObject={registerObject} control={control} arrayModal={data?.statements} name="statements"></TodoList>
                    </div>
                    <div className="statement-modal-bar" />
                    <div className="robot_reply-container">
                        <Field label="Robot Reply" />
                        <TodoList registerObject={registerObject} control={control} arrayModal={data?.reponses} name="responses"></TodoList>
                    </div>

                </Form.Body >
                <Form.Buttons>
                    {is_button_back ? <div className="button_add_statement" style={{ marginRight: '20px' }}>
                        <ButtonAction className="cancel" label={<i className="fas fa-angle-double-left"></i>} onClick={() => ScrollIntoSlide('test-part')}></ButtonAction>
                    </div> : null}
                    <ButtonAction type="button" label={data?.id ? "Update" : "Add"} disabled={Object.keys(errors).length == 0 ? (getValues().label != "" ? false : true) : true} onClick={handleSubmit(onSubmit)}></ButtonAction>
                </Form.Buttons>
            </Form >
        </div >

    );
}

export default StatementModalBody;